import React, { useState } from "react";
import Button from '../../components/Button';
import VideoPlayer from "../../components/VideoPlayer";

export default function PraxiasNeuromusculares() {

  const [videoAbierto, setVideoAbierto] = useState(null);

  const abrirVideo = (url) => {
    setVideoAbierto(url);
  };

  const cerrarVideo = () => {
    setVideoAbierto(null);
  };

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">

      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Praxias neuromusculares</h4>
      </div>

      {/* Introducción */}
      <div className="text-justify">
        <p className="mb-2">Las praxias orofaciales son ejercicios sencillos para mejorar la fisiología de la deglución.</p>

        <p className="mb-2">Dirigidas a mejorar la movilidad, fuerza, tono y recorrido articular.</p>

        <p className="mb-4">
            Al realizarlos, es importante que el/la paciente permanezca sentado/a, con la espalda recta, 
            tranquilo, delante de un espejo y sin distracciones.
        </p>

        <p>A continuación, se presentan diferentes enlaces que llevan a ejercicios que puede realizar:</p>
      </div>

      {/* Ejercicios de lengua -> Enlaces */}

      <div className="flex flex-col gap-4 mt-2 font-semibold bg-white border rounded-lg p-4">
        <a
          href="https://disfapp.es/ejercicios-de-lengua-1"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de lengua (Ejercicio 01)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-lengua-2"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de lengua (Ejercicio 02)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-lengua-3"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de lengua (Ejercicio 03)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-lengua-4"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de lengua (Ejercicio 04)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-lengua-5"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de lengua (Ejercicio 05)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-lengua-6"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de lengua (Ejercicio 06)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-lengua-7"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de lengua (Ejercicio 07)</Button>
        </a>

        {/* Video 01 */}
        <Button onClick={() => abrirVideo("/videos/ejercicio-de-fuerza-lingual.mp4")}>
          Ejercicio de fuerza lingual (Video)
        </Button>

        {/* Video 02 */}
        <Button onClick={() => abrirVideo("/videos/ejercicio-de-movilidad-de-lengua.mp4")}>
          Ejercicio de movilidad de lengua (Video)
        </Button>
      </div>

      {/* Ejercicios de labios y mejillas -> Enlaces */}

      <div className="flex flex-col gap-4 mt-2 font-semibold bg-white border rounded-lg p-4">
        <a
          href="https://disfapp.es/ejercicios-de-labios-y-mejillas-1"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de labios y mejillas (Ejercicio 01)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-labios-y-mejillas-2"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de labios y mejillas (Ejercicio 02)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-labios-y-mejillas-3"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de labios y mejillas (Ejercicio 03)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-labios-y-mejillas-4"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de labios y mejillas (Ejercicio 04)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-labios-y-mejillas-5"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de labios y mejillas (Ejercicio 05)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-labios-y-mejillas-6"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de labios y mejillas (Ejercicio 06)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-labios-y-mejillas-7"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de labios y mejillas (Ejercicio 07)</Button>
        </a>

        {/* Video 01 */}
        <Button onClick={() => abrirVideo("/videos/ejercicio-para-fortalecer-el-sello-labial.mp4")}>
          Ejercicio para fortalecer el sello labial (Video)
        </Button>
      </div>

      {/* Ejercicios de velo de paladar y elevación laríngea -> Enlaces */}

      <div className="flex flex-col gap-4 mt-2 font-semibold bg-white border rounded-lg p-4">
        <a
          href="https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-1"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de velo de paladar y elevación laríngea (Ejercicio 01)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-2"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de velo de paladar y elevación laríngea (Ejercicio 02)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-3"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de velo de paladar y elevación laríngea (Ejercicio 03)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-4"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de velo de paladar y elevación laríngea (Ejercicio 04)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-5"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de velo de paladar y elevación laríngea (Ejercicio 05)</Button>
        </a>

        <a
          href="https://disfapp.es/ejercicios-de-velo-de-paladar-y-elevacion-laringea-6"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de velo de paladar y elevación laríngea (Ejercicio 06)</Button>
        </a>

        {/* Video */}
        <Button onClick={() => abrirVideo("/videos/ejercicio-de-velo-del-paladar-y-coaptacion-de-cuerdas-vocales.mp4")}>
          Ejercicio de velo del paladar y coaptacion de cuerdas vocales (Video)
        </Button>
      </div>

      {/* Ejercicio de Saker -> Enlaces */}

      <div className="flex flex-col gap-4 mt-2 font-semibold bg-white border rounded-lg p-4">
        <a
          href="https://disfapp.es/ejercicios-de-saker"
          target="_blank"
          rel="noopener noreferrer"
          className="w-full"
        >
          <Button className="w-full">Ejercicio de Saker</Button>
        </a>
      </div>

      {/* Videos faltantes */}

      <div className="flex flex-col gap-4 mt-2 font-semibold bg-white border rounded-lg p-4">
        {/* Video 1 */}
        <Button onClick={() => abrirVideo("/videos/ejercicio-para-potenciar-musculatura-buccinadora.mp4")}>
          Ejercicio para potenciar musculatura buccinadora (Video)
        </Button>

        {/* Video 2 */}
        <Button onClick={() => abrirVideo("/videos/ejercicio-para-potenciar-la-musculatura-suprahioidea.mp4")}>
          Ejercicio para potenciar la musculatura suprahioidea (Video)
        </Button>
      </div>

      {/* Modal VideoPlayer */}
      {videoAbierto && (
        <VideoPlayer videoUrl={videoAbierto} onClose={cerrarVideo} />
      )}
    </div>
  );
}